import { useCallback } from 'react';

import { componentLogger } from '@ragu-components/logger';
import { HttpError, useTranslate } from 'react-admin';

import { useIngordDataProvider } from 'src/components/flowchart/hooks/useIngordDataProvider';

interface SaveResult {
  success: boolean;
  error?: string;
}

interface UseQueueRecordingConfsOperationsReturn {
  saveQueues: (confId: string, queueIds: string[]) => Promise<SaveResult>;
}

export const useQueueRecordingConfsOperations = (): UseQueueRecordingConfsOperationsReturn => {
  const dataProvider = useIngordDataProvider();
  const translate = useTranslate();

  const saveQueues = useCallback(
    async (confId: string, queueIds: string[]): Promise<SaveResult> => {
      try {
        await dataProvider.replaceCallRecordingConfQueues(confId, queueIds);
        return { success: true };
      } catch (error) {
        componentLogger.error('Error replacing queue call recording conf assignments', error);
        const message = error instanceof HttpError ? translate(error.message, { _: error.message }) : undefined;
        return { success: false, error: message };
      }
    },
    [dataProvider, translate]
  );

  return { saveQueues };
};
